﻿/*!
    *
    * Wijmo Library 5.20251.31
    * https://developer.mescius.com/wijmo
    *
    * Copyright(c) MESCIUS inc. All rights reserved.
    *
    * Licensed under the End-User License Agreement For MESCIUS Wijmo Software.
    * us.sales@mescius.com
    * https://developer.mescius.com/wijmo/licensing
    *
    */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { _getModule, _registerModule } from '@mescius/wijmo';
import * as wjcInput from '@mescius/wijmo.input';
import * as wjcCore from '@mescius/wijmo';
import * as wjcGrid from '@mescius/wijmo.grid';
import * as selfModule from '@mescius/wijmo.interop.grid';
export function softInput() {
    return _getModule('wijmo.input');
}
export function softGridDetail() {
    return _getModule('wijmo.grid.detail');
}
//import * as wjcGridDetail from '@mescius/wijmo.grid.detail';
// Mockup for CellFactory in global modules, to allow DirectiveCellFactory be loaded in case 
// of absent wijmo.grid module.
var __gridCFRef = wjcGrid && wjcGrid.CellFactory;
if (!__gridCFRef) {
    window['wijmo'].grid = {};
    window['wijmo'].grid.CellFactory = function () { };
}
var DirectiveCellFactoryBase = /** @class */ (function (_super) {
    __extends(DirectiveCellFactoryBase, _super);
    function DirectiveCellFactoryBase(grid /*, gridCdRef: ChangeDetectorRef*/) {
        var _this = _super.call(this) || this;
        _this._lastApplyTimeStamp = 0;
        _this._noApplyLag = false;
        _this._startingEditing = false;
        _this._cellStampCounter = 0;
        _this._composing = false;
        _this._autoSizeCache = {};
        _this._isCheckingHeight = false;
        _this._backupHeight = -1;
        _this._cacheRow = null;
        _this.grid = grid;
        //this._gridCdRef = gridCdRef;
        // init _templateTypes
        if (!DirectiveCellFactoryBase._templateTypes) {
            DirectiveCellFactoryBase._templateTypes = [];
            for (var templateType in GridCellTemplateType) {
                if (isNaN(templateType)) {
                    DirectiveCellFactoryBase._templateTypes.push(templateType);
                }
            }
        }
        var self = _this;
        _this._baseCf = grid.cellFactory;
        grid.cellFactory = _this;
        // initialize input event dispatcher
        _this._evtInput = document.createEvent('HTMLEvents');
        _this._evtInput.initEvent('input', true, false);
        // initialize blur event dispatcher
        _this._evtBlur = document.createEvent('HTMLEvents');
        _this._evtBlur.initEvent('blur', false, false);
        // no $apply() lag while editing
        grid.prepareCellForEdit.addHandler(function (s, e) {
            self._noApplyLag = true;
        });
        grid.cellEditEnded.addHandler(function (s, e) {
            var rng = e.range, colIdx = rng.col;
            // If column has no cell edit template, clear _editChar buffer.
            if (colIdx < 0 || colIdx < grid.columns.length) {
                //!grid.columns[e.range.col][DirectiveCellFactoryBase.getTemplContextProp(GridCellTemplateType.CellEdit)]) {
                var bindCol = grid._getBindingColumn(grid.cells, rng.row, grid.columns[colIdx]);
                if (!bindCol || !bindCol[DirectiveCellFactoryBase.getTemplContextProp(GridCellTemplateType.CellEdit)]) {
                    self._editChar = null;
                }
            }
            setTimeout(function () {
                self._noApplyLag = false;
            }, 300);
        });
        grid.beginningEdit.addHandler(function (s, e) {
            self._startingEditing = true;
        });
        grid.addEventListener(grid.hostElement, 'keydown', function (e) {
            self._startingEditing = false;
        }, true);
        grid.addEventListener(grid.hostElement, 'keypress', function (e) {
            var char = e.charCode > 32 ? String.fromCharCode(e.charCode) : null;
            // check also that it has been happened not in a nested grid
            if (char && wjcCore.closest(e.target, "." + wjcGrid.FlexGridClsNames.hostElement) === grid.hostElement) {
                // Grid's _KeyboardHandler may receive 'keypress' before or after this handler (observed at least in IE,
                // not clear why this happens). So both grid.activeEditor and _startingEditing (the latter is initialized in
                // beginningEdit and cleared in 'keydown') participate in detecting whether this char has initialized a cell
                // editing.
                if (!grid.activeEditor || self._startingEditing) {
                    self._editChar = char;
                    setTimeout(function () {
                        // if grid didn't get into an edit mode after a while then clear the buffer -
                        // this was input not related to editing, e.g. input to a read-only cell
                        // or somewhere else.
                        if (!grid.activeEditor) {
                            self._editChar = null;
                        }
                    }, 0);
                }
                else if (self._editChar) {
                    self._editChar += char;
                }
            }
        }, true);
        grid.addEventListener(grid.hostElement, 'compositionstart', function (e) {
            self._composing = true;
        }, true);
        grid.addEventListener(grid.hostElement, 'compositionend', function (e) {
            self._composing = false;
        }, true);
        grid.updatedView.addHandler(function (s, e) {
            _this._updatedViewHandler();
        });
        return _this;
    }
    DirectiveCellFactoryBase.prototype._updatedViewHandler = function () {
        var _this = this;
        // auto size only if any of the pending row wasn't resized in past
        queueMicrotask(function () {
            _this._autoSizeIfRequired();
        });
    };
    DirectiveCellFactoryBase.prototype.canRender = function (tplCtx) {
        return !!tplCtx;
    };
    DirectiveCellFactoryBase.prototype.updateCell = function (panel, rowIndex, colIndex, cell, rng) {
        this._cellStampCounter = (this._cellStampCounter + 1) % 10000000;
        var cellStamp = cell[DirectiveCellFactoryBase._cellStampProp] = this._cellStampCounter;
        // restore overflow for any cell
        if (cell.style.overflow) {
            cell.style.overflow = '';
        }
        var riOriginal = rowIndex, ciOriginal = colIndex;
        if (rng && !rng.isSingleCell) {
            rowIndex = rng.row;
            colIndex = rng.col;
        }
        var self = this, grid = panel.grid, editRange = grid.editRange, templateType, row = panel.rows[rowIndex], dataItem = row.dataItem, isGridCtx = false, needCellValue = false, isEdit = false, isCvGroup = false;
        // determine template type
        switch (panel.cellType) {
            case wjcGrid.CellType.Cell:
                if (editRange && editRange.row === rowIndex && editRange.col === colIndex) {
                    templateType = GridCellTemplateType.CellEdit;
                    needCellValue = isEdit = true;
                }
                else if (row instanceof wjcGrid.GroupRow) {
                    isCvGroup = dataItem instanceof wjcCore.CollectionViewGroup;
                    var isHierNonGroup = !(isCvGroup || row.hasChildren);
                    if (colIndex == panel.columns.firstVisibleIndex) {
                        templateType = isHierNonGroup ? GridCellTemplateType.Cell : GridCellTemplateType.GroupHeader;
                    }
                    else {
                        templateType = isHierNonGroup ? GridCellTemplateType.Cell : GridCellTemplateType.Group;
                        needCellValue = true;
                    }
                }
                else if (row instanceof wjcGrid._NewRowTemplate) {
                    templateType = GridCellTemplateType.NewCellTemplate;
                }
                else if (!(softGridDetail() && softGridDetail().DetailRow &&
                    (row instanceof softGridDetail().DetailRow))) {
                    templateType = GridCellTemplateType.Cell;
                }
                break;
            case wjcGrid.CellType.ColumnHeader:
                templateType = GridCellTemplateType.ColumnHeader;
                break;
            case wjcGrid.CellType.RowHeader:
                templateType = grid.collectionView &&
                    grid.collectionView.currentEditItem === dataItem
                    ? GridCellTemplateType.RowHeaderEdit
                    : GridCellTemplateType.RowHeader;
                isGridCtx = true;
                break;
            case wjcGrid.CellType.TopLeft:
                templateType = GridCellTemplateType.TopLeft;
                isGridCtx = true;
                break;
            case wjcGrid.CellType.ColumnFooter:
                templateType = GridCellTemplateType.ColumnFooter;
                needCellValue = true;
                break;
            case wjcGrid.CellType.BottomLeft:
                templateType = GridCellTemplateType.BottomLeft;
                isGridCtx = true;
                break;
        }
        var isUpdated = false;
        if (templateType != null) {
            var col = null;
            if (isCvGroup && templateType == GridCellTemplateType.GroupHeader) {
                col = grid.getColumn(dataItem.groupDescription['propertyName']);
            }
            else if (colIndex >= 0 && colIndex < panel.columns.length) {
                if (panel.cellType === wjcGrid.CellType.ColumnHeader && grid._hasColumnGroups()) {
                    col = grid._getColumnGroup(rowIndex, colIndex);
                }
                else {
                    col = grid._getBindingColumn(panel, rowIndex, panel.columns[colIndex]);
                }
            }
            if (col) {
                var getTemplContextProp = DirectiveCellFactoryBase.getTemplContextProp, templContextProp = getTemplContextProp(templateType), templContext = (isGridCtx ? grid : col)[templContextProp];
                // maintain template inheritance
                if (!templContext) {
                    if (templateType === GridCellTemplateType.RowHeaderEdit) {
                        templateType = GridCellTemplateType.RowHeader;
                        templContextProp = getTemplContextProp(templateType);
                        templContext = grid[templContextProp];
                    }
                    else if (templateType === GridCellTemplateType.Group || templateType === GridCellTemplateType.GroupHeader) {
                        if (!isCvGroup) {
                            templateType = GridCellTemplateType.Cell;
                            templContextProp = getTemplContextProp(templateType);
                            templContext = col[templContextProp];
                        }
                    }
                }
                // process template
                if (templContext && this.canRender(templContext)) {
                    isUpdated = this._processTemplate(panel, rowIndex, colIndex, cell, templContext, {
                        needCellValue: needCellValue,
                        isCvGroup: isCvGroup,
                        isEdit: isEdit,
                        riOriginal: riOriginal,
                        ciOriginal: ciOriginal,
                        rng: rng,
                        templContextProp: templContextProp,
                        col: col,
                        row: row
                    });
                }
            }
        }
        if (!isUpdated) {
            this._doDisposeCell(cell);
            this._baseCf.updateCell(panel, riOriginal, ciOriginal, cell, rng);
        }
    };
    // manage rendering of template context
    DirectiveCellFactoryBase.prototype._processTemplate = function (panel, rowIndex, colIndex, cell, templContext, ctx) {
        var _this = this;
        // vars for easy acess
        var isUpdated = true, needCellValue = ctx.needCellValue, isCvGroup = ctx.isCvGroup, isEdit = ctx.isEdit, grid = panel.grid, row = ctx.row, col = ctx.col, riOriginal = ctx.riOriginal, ciOriginal = ctx.ciOriginal, rng = ctx.rng, templContextProp = ctx.templContextProp;
        var cellStamp = cell[DirectiveCellFactoryBase._cellStampProp], self = this;
        // apply directive template and style
        var cellValue, cellValueFormatted;
        if (needCellValue) {
            cellValue = panel.getCellData(rowIndex, colIndex, false);
            cellValueFormatted = panel.getCellData(rowIndex, colIndex, true);
        }
        // determine if group summary needs rendering
        var isGrSummary = isCvGroup ? row.isSummary : false;
        var isGrSummaryVisible = isCvGroup && (grid.groupSummaryPosition === wjcGrid.GroupSummaryPosition.Bottom ||
            (grid.groupSummaryPosition === wjcGrid.GroupSummaryPosition.Auto &&
                !row.isCollapsed));
        // apply cell template
        var measureAttr = cell.getAttribute(wjcGrid.FlexGrid._WJS_MEASURE), isMeasuring = measureAttr && measureAttr.toLowerCase() === 'true';
        if (isEdit) {
            this.clearCell(cell);
            this._baseCf.updateCell(panel, riOriginal, ciOriginal, cell, rng, true);
        }
        var 
        // Grid uses "ime editor" if grid.imeEnabled=true, even if not
        // an IME input is currently happening. So we need to differentiate
        // this two different modes, in the isImeInput and isTrueImeInput
        // variables.
        isImeInput = isEdit && grid.imeEnabled, isTrueImeInput = isImeInput && this._composing, cellContext = (cell[templContextProp]), //can be a null
        cellRenderInfo = {
            cell: cell,
            column: col,
            row: row,
            panel: panel,
            rng: rng,
            isEdit: isEdit,
            isImeInput: isImeInput,
            isTrueImeInput: isTrueImeInput,
            templateContext: templContext,
            templateCache: cellContext,
            templateContextProperty: templContextProp,
            cellStamp: cellStamp,
            cellValue: cellValue,
            cellValueFormatted: cellValueFormatted,
        }, isForeignCell = this.shouldInstantiate(cellRenderInfo);
        var cellInfo;
        var canRenderTemplate = true;
        if (isCvGroup) {
            if (!isGrSummary && colIndex != panel.columns.firstVisibleIndex && isGrSummaryVisible) {
                canRenderTemplate = false;
            }
        }
        if (isForeignCell) {
            if (isEdit) {
                var rootEl = cell.firstElementChild;
                if (rootEl) {
                    // set focus to cell, because hiding a focused element may move focus to a page body
                    // that will force Grid to finish editing.
                    if (!isImeInput) {
                        cell.focus();
                    }
                    rootEl.style.display = 'none';
                }
            }
            else {
                this.clearCell(cell);
            }
            // TBD: moved up; check if it's Ok for isEdit==true
            this._doDisposeCell(cell);
            if (canRenderTemplate) {
                this.renderTemplate(cellRenderInfo, true);
                cellRenderInfo.templateCache = cellContext = cell[templContextProp];
            }
            else {
                // this._doDisposeCell(cell);
            }
            cellInfo = cellRenderInfo.cellBindingsData;
        }
        else {
            if (canRenderTemplate) {
                this.renderTemplate(cellRenderInfo, false);
            }
            else {
                this._doDisposeCell(cell);
            }
            cellInfo = cellRenderInfo.cellBindingsData;
        }
        if (templContext.cellOverflow) {
            cell.style.overflow = templContext.cellOverflow;
        }
        if (isMeasuring) {
            //force local template 'cell' var values to be applied immediately
            this.applyImmediately(cellRenderInfo);
        }
        else if (templContext.autoSizeRows && !isImeInput) {
            // mark for autoSize
            this._markForAutoSize(rowIndex, colIndex, panel);
        }
        if (isEdit) {
            // update row height
            if (canRenderTemplate) {
                queueMicrotask(function () {
                    _this._updateEditRowSize(panel, rowIndex, colIndex, cell);
                });
            }
            setTimeout(function () {
                //AlexI
                if (isImeInput) {
                    _this._initImeEditInput(cellRenderInfo.cell, templContext);
                }
                else {
                    _this._initEditInput(cellRenderInfo.cell, templContext, null);
                }
            }, 0);
        }
        if (isEdit) {
            self._cellEditorVars = cellInfo.localVars;
            var editEndingEH = function (s, e) {
                grid.cellEditEnding.removeHandler(editEndingEH);
                // Move focus out of the current input element, in order to let it to save
                // its value (necessary for controls like InputDate that can't update value immediately
                // as user typing).
                // We do it via event emulation, instead of moving focus to another element,
                // because in IE an element doesn't fit in time to receive the 'blur' event.
                if (!e.stayInEditMode) {
                    var activeElement = wjcCore.getActiveElement();
                    if (activeElement) {
                        activeElement.dispatchEvent(self._evtBlur);
                    }
                    // We need to move focus nevertheless, because without this grid may lose focus at all in IE.
                    if (wjcCore.contains(cell, wjcCore.getActiveElement())) {
                        cell.focus();
                    }
                }
                self._triggerEditorEvents(cell);
                if (!(e.cancel || e.stayInEditMode)) {
                    //e.cancel = true;
                    var cellVar = cellInfo.localVars, 
                    //newVal = cellVar.value,
                    bindNames = Object.getOwnPropertyNames(cellInfo.bindings);
                    // set cell value
                    //panel.grid.setCellData(rowIndex, colIndex, newVal);
                    // set values for valuePaths
                    for (var _i = 0, bindNames_1 = bindNames; _i < bindNames_1.length; _i++) {
                        var curName = bindNames_1[_i];
                        cellInfo.bindings[curName].setValue(cellVar, cellInfo.localVars.values[curName]);
                    }
                }
                // close all open dropdowns 
                var dropDowns = cell.querySelectorAll("." + wjcInput.DropDownClsNames.hostElement);
                [].forEach.call(dropDowns, function (el) {
                    var ctrl = wjcCore.Control.getControl(el);
                    if (ctrl && softInput() && ctrl instanceof softInput().DropDown) {
                        ctrl.isDroppedDown = false;
                    }
                });
            };
            var editEndedEH_1 = function (s, e) {
                grid.cellEditEnded.removeHandler(editEndedEH_1);
                self._cellEditorVars = null;
            };
            // subscribe the handler to the cellEditEnding event
            grid.cellEditEnding.addHandler(editEndingEH);
            grid.cellEditEnded.addHandler(editEndedEH_1);
        }
        else {
            this._baseCf.updateCell(panel, riOriginal, ciOriginal, cell, rng, false);
        }
        return isUpdated;
    };
    // update row height for edit cell
    DirectiveCellFactoryBase.prototype._updateEditRowSize = function (panel, r, c, cell) {
        var _this = this;
        var row = panel.rows[r];
        var newHeight = this.getHeight(panel, r, c, cell);
        var headerHeight = 0;
        if (this.grid.rowHeaders.columns[0] && this.grid.rowHeaders.columns[0].isVisible) {
            try {
                headerHeight = this.getHeight(this.grid.rowHeaders, r, 0, this.grid.rowHeaders.getCellElement(r, 0));
            }
            catch (err) { }
        }
        if (headerHeight > newHeight) {
            newHeight = headerHeight;
        }
        if (!row.resizedManually && newHeight > row.renderHeight) {
            var backupHeight_1 = row.height;
            row.height = newHeight;
            if (this.grid["_toInv"]) {
                // prevent automatic refresh, otherwise edit mode will end
                clearTimeout(this.grid["_toInv"]);
                this.grid._listenResizeEvents = false;
                this.grid.refreshCells(true);
                // clear flag in next tick
                setTimeout(function () {
                    _this.grid._listenResizeEvents = true;
                });
            }
            var endedHandler_1 = function (s, e) {
                row["_editHandler"] = null;
                s.rowEditEnded.removeHandler(endedHandler_1);
                if (s.rows[r])
                    s.rows[r].height = backupHeight_1 || null;
            };
            if (!row["_editHandler"]) {
                row["_editHandler"] = endedHandler_1;
                this.grid.rowEditEnded.addHandler(endedHandler_1);
            }
        }
    };
    DirectiveCellFactoryBase.prototype._autoSizePanelCells = function (panel, headerPanel, cache) {
        var updated = false;
        // iterate rows and set size
        var r;
        var visibleColsCount = 0;
        var isRowHeaderVisible = false;
        var editingItem = panel.grid.editableCollectionView && panel.grid.editableCollectionView.currentEditItem;
        for (var _i = 0, _a = panel.columns; _i < _a.length; _i++) {
            var col = _a[_i];
            if (col.isVisible) {
                visibleColsCount++;
            }
        }
        for (var _b = 0, _c = headerPanel.columns; _b < _c.length; _b++) {
            var col = _c[_b];
            if (col.isVisible) {
                isRowHeaderVisible = true;
                break;
            }
        }
        var defaultRowsSize = panel.rows.defaultSize;
        for (r in cache) {
            r = parseInt(r);
            if (!panel.rows[r] || (editingItem && panel.rows[r].dataItem === editingItem)) {
                continue;
            }
            if (panel.rows[r].resizedManually || panel.rows[r].detail != null) { // detail rows are resized by detail provider
                continue;
            }
            var headerCols = Array.from(cache[r].rowHeader);
            var cols = Array.from(cache[r].cell);
            var height = -1;
            for (var _d = 0, headerCols_1 = headerCols; _d < headerCols_1.length; _d++) {
                var c = headerCols_1[_d];
                var cell = headerPanel.getCellElement(r, c);
                if (cell && (!cell["$__cellTemplRowHeaderEdit"] || (cell["$__cellTemplRowHeaderEdit"] && editingItem))) {
                    var h = this.getHeight(headerPanel, r, c, cell);
                    if (h > height) {
                        height = h;
                    }
                }
            }
            for (var _e = 0, cols_1 = cols; _e < cols_1.length; _e++) {
                var c = cols_1[_e];
                var cell = panel.getCellElement(r, c);
                if (cell) {
                    var h = this.getHeight(panel, r, c, cell);
                    if (h > height) {
                        height = h;
                    }
                }
            }
            // if one of the columns have templates and other do not
            if (cols.length != visibleColsCount && defaultRowsSize > height) {
                height = defaultRowsSize;
            }
            // Consider rowHeaders for defaultSize too when all visible columns have templates.
            // Condition:
            //      - at least one column in rowHeaders should be visible.
            //      - rowHeader template should not be present.
            if ((panel.grid.headersVisibility & wjcGrid.HeadersVisibility.Row) && isRowHeaderVisible && headerCols.length === 0 && defaultRowsSize > height) {
                height = defaultRowsSize;
            }
            // WJM-35836, only increase height, don't decrease it 
            if (panel.rows[r].height && panel.rows[r].height > height) {
                continue;
            }
            // diff should be greater than 1 px to avoid flickering in some cases
            // bcz border consumes 1 px and that could give a size diff of 1 px if temp is smaller
            if (height > -1 && Math.abs(panel.rows[r].height - height) > 1) {
                panel.rows[r].height = height;
                updated = true;
            }
        }
        return updated;
    };
    DirectiveCellFactoryBase.prototype.getHeight = function (panel, r, c, cell) {
        var cellHeight = cell.scrollHeight, panelRows = panel.rows, rng = panel.grid.getMergedRange(panel, r, c, false), rowSpan = rng && rng.rowSpan || 1;
        if (cell.firstElementChild) {
            var compStyle = getComputedStyle(cell);
            var paddingHeight = (parseFloat(compStyle.paddingTop) || 0) + (parseFloat(compStyle.paddingBottom) || 0), borderHeight = (parseFloat(compStyle.borderBottomWidth) || 0) + (parseFloat(compStyle.borderTopWidth) || 0), // (WJM-34063)
            th = cell.firstElementChild.scrollHeight + paddingHeight + borderHeight;
            // for vue samples
            if (cell.firstElementChild.childNodes.length > 0) {
                if (cell.firstElementChild.scrollHeight != 0) {
                    cellHeight = th;
                }
            }
        }
        if (panelRows.maxSize != null) {
            cellHeight = Math.min(cellHeight, panelRows.maxSize);
        }
        var height = cellHeight / rowSpan;
        return height;
    };
    DirectiveCellFactoryBase.prototype._autoSizeIfRequired = function () {
        var eRng = this.grid.editRange;
        if ((eRng && this.grid.columns[eRng.col]) || (this.grid._mouseHdl._isDown && this.grid._mouseHdl._szArgs)) {
            this._autoSizeCache = {};
            return;
        }
        var vr = this.grid.viewRange;
        // no cache
        if (!this._autoSizeCache || !this._autoSizeCache["pendingCells"]) {
            return;
        }
        for (var r = vr.topRow; r <= vr.bottomRow; r++) {
            if (this._autoSizeCache["pendingCells"]["cells"] && this._autoSizeCache["pendingCells"]["cells"][r]) {
                this._autoSizePendingCells();
                return;
            }
            if (this._autoSizeCache["pendingCells"]["headers"] && this._autoSizeCache["pendingCells"]["headers"][r]) {
                this._autoSizePendingCells();
                return;
            }
            if (this._autoSizeCache["pendingCells"]["footers"] && this._autoSizeCache["pendingCells"]["footers"][r]) {
                this._autoSizePendingCells();
                return;
            }
        }
    };
    DirectiveCellFactoryBase.prototype._autoSizePendingCells = function () {
        var hUpdated = false, cUpdated = false, fUpdated = false;
        try {
            this.grid.beginUpdate();
            // no cache
            if (!this._autoSizeCache || !this._autoSizeCache["pendingCells"]) {
                return;
            }
            // autoSize headers
            if (this._autoSizeCache["pendingCells"]["headers"]) {
                hUpdated = this._autoSizePanelCells(this.grid.columnHeaders, this.grid.topLeftCells, this._autoSizeCache["pendingCells"]["headers"]);
            }
            // autoSize cells
            if (this._autoSizeCache["pendingCells"]["cells"]) {
                cUpdated = this._autoSizePanelCells(this.grid.cells, this.grid.rowHeaders, this._autoSizeCache["pendingCells"]["cells"]);
            }
            // autoSize footers
            if (this._autoSizeCache["pendingCells"]["footers"]) {
                fUpdated = this._autoSizePanelCells(this.grid.columnFooters, this.grid.bottomLeftCells, this._autoSizeCache["pendingCells"]["footers"]);
            }
            this._autoSizeCache = {};
        }
        finally {
            this.grid.endUpdate(hUpdated || cUpdated || fUpdated);
        }
    };
    DirectiveCellFactoryBase.prototype._markForAutoSize = function (rowIndex, colIndex, panel) {
        var cache, isHeader = false;
        if (!this._autoSizeCache["pendingCells"]) {
            this._autoSizeCache["pendingCells"] = {};
        }
        switch (panel.cellType) {
            case wjcGrid.CellType.TopLeft: {
                isHeader = true;
            }
            case wjcGrid.CellType.ColumnHeader: {
                if (!this._autoSizeCache["pendingCells"]["headers"]) {
                    this._autoSizeCache["pendingCells"]["headers"] = {};
                }
                cache = this._autoSizeCache["pendingCells"]["headers"];
                break;
            }
            case wjcGrid.CellType.RowHeader: {
                isHeader = true;
            }
            case wjcGrid.CellType.Cell: {
                if (!this._autoSizeCache["pendingCells"]["cells"]) {
                    this._autoSizeCache["pendingCells"]["cells"] = {};
                }
                cache = this._autoSizeCache["pendingCells"]["cells"];
                break;
            }
            case wjcGrid.CellType.BottomLeft: {
                isHeader = true;
            }
            case wjcGrid.CellType.ColumnFooter: {
                if (!this._autoSizeCache["pendingCells"]["footers"]) {
                    this._autoSizeCache["pendingCells"]["footers"] = {};
                }
                cache = this._autoSizeCache["pendingCells"]["footers"];
                break;
            }
            default: return;
        }
        if (!cache[rowIndex]) {
            cache[rowIndex] = {
                rowHeader: new Set(),
                cell: new Set()
            };
        }
        if (isHeader) {
            cache[rowIndex]["rowHeader"].add(colIndex);
        }
        else {
            cache[rowIndex]["cell"].add(colIndex);
        }
    };
    DirectiveCellFactoryBase.prototype.getEditorValue = function (g) {
        if (this._cellEditorVars) {
            // trigger all pending async events in the child Wijmo controls immediately
            var editRange = g.editRange;
            if (editRange && editRange.isValid) {
                this._triggerEditorEvents(g.cells.getCellElement(editRange.row, editRange.col));
            }
            return this._cellEditorVars.value;
        }
        else {
            return _super.prototype.getEditorValue.call(this, g);
        }
    };
    DirectiveCellFactoryBase.prototype.disposeCell = function (cell) {
        this._doDisposeCell(cell);
    };
    DirectiveCellFactoryBase.prototype.disposeTemplate = function (cell, templateCache, templateContext) {
        if (templateCache) {
            templateCache.rootElement = null;
            templateCache.column = null;
            cell[templateCache.templateContextProperty] = null;
            templateCache.templateContextProperty = null;
        }
    };
    //protected abstract instantiateTemplate(cellInfo: ICellRenderingInfo);
    DirectiveCellFactoryBase.prototype.setBindingsData = function (context, row, col, dataItem, cellValue, valuePaths) {
        //this._needsCdCheck = true;
        context.row = row;
        context.col = col;
        context.item = dataItem;
        var values = {}, 
        //cellCtx = { row: row, col: col, item: dataItem, value: cellValue, values: values },
        cellCtx = context.cell || {}, bindings = {}, ret = { localVars: cellCtx, bindings: bindings };
        cellCtx.row = row;
        cellCtx.col = col;
        cellCtx.item = dataItem;
        cellCtx.value = cellValue;
        cellCtx.valueFormatted = context.cellValueFormatted;
        cellCtx.values = values;
        if (valuePaths) {
            var pathNames = Object.getOwnPropertyNames(valuePaths);
            for (var _i = 0, pathNames_1 = pathNames; _i < pathNames_1.length; _i++) {
                var pName = pathNames_1[_i];
                var binding = new wjcCore.Binding(valuePaths[pName]);
                bindings[pName] = binding;
                values[pName] = binding.getValue(cellCtx);
            }
        }
        if (context.cell !== cellCtx) {
            context.cell = cellCtx;
        }
        return ret;
    };
    DirectiveCellFactoryBase.prototype.checkHeight = function (cellInfo) {
        var _this = this;
        if (this._isCheckingHeight)
            return;
        //console.log(`checkHeight`)
        setTimeout(function () {
            var cell = cellInfo.cell;
            // ignore the cell if it is already obsolete at this moment
            if (cellInfo.cellStamp !== cell[DirectiveCellFactoryBase._cellStampProp]) {
                return;
            }
            var cellHeight = cell.scrollHeight, panelRows = cellInfo.panel.rows, rowIndex = cellInfo.row.index, rng = cellInfo.rng, rowSpan = rng && rng.rowSpan || 1, isEdit = cellInfo.isEdit;
            if (panelRows.maxSize != null) {
                cellHeight = Math.min(cellHeight, panelRows.maxSize);
            }
            // TBD: it's not clear why we need (cellHeight - 1), but without it may get to an 
            // infinite loop. It's not the issue in Ng2 Explorer.
            if (rowIndex < panelRows.length &&
                (panelRows[rowIndex].renderHeight * rowSpan) < (cellHeight - 1)) {
                var height = cellHeight / rowSpan;
                if (isEdit) {
                    var isFullEdit = _this._isFullEdit(), grid = _this.grid;
                    //if (grid.autoRowHeights) //wjm-23242 always need the height display editor fully.
                    {
                        // reset row height and prevent infinite loop when FlexGrid autoRowHeights is true (WJM-20781)                        
                        _this._backupHeight = cellInfo.row.height;
                        cellInfo.row.height = height;
                        _this._cacheRow = cellInfo.row;
                    }
                    _this._isCheckingHeight = true;
                    grid.refresh();
                    grid.startEditing(isFullEdit);
                    _this._isCheckingHeight = false;
                    // return;
                }
            }
            if (isEdit) { // Fix for Issue with Focus on custom editor when selected first time (WJM-30258)
                if (cellInfo.isImeInput) {
                    _this._initImeEditInput(cellInfo.cell, cellInfo.templateContext);
                }
                else {
                    _this._initEditInput(cellInfo.cell, cellInfo.templateContext, null);
                }
            }
            ;
        }, 0);
    };
    DirectiveCellFactoryBase.prototype._restoreRowHeight = function () {
        if (!this._isCheckingHeight && this._cacheRow) {
            this._cacheRow.height = this._backupHeight;
            this._backupHeight = -1;
            this._cacheRow = null;
        }
    };
    DirectiveCellFactoryBase.prototype.doDisposeCell = function (cell) {
        var ttm = DirectiveCellFactoryBase._templateTypes;
        for (var i = 0; i < ttm.length; i++) {
            var templContextProp = DirectiveCellFactoryBase.getTemplContextProp(GridCellTemplateType[ttm[i]]), cellContext = (cell[templContextProp]);
            if (cellContext) {
                var templateOwner = cellContext.column || this.grid, templateContext = templateOwner[templContextProp];
                this.disposeTemplate(cell, cellContext, templateContext);
                if (ttm[i] == GridCellTemplateType[GridCellTemplateType.CellEdit])
                    this._restoreRowHeight();
            }
            // if (cellContext && cellContext.viewRef) {
            //     let templateOwner = cellContext.column || this.grid,
            //         templateContext = <WjFlexGridCellTemplate>templateOwner[templContextProp];
            //     if (templateContext) {
            //         let viewIdx = templateContext.viewContainerRef.indexOf(cellContext.viewRef);
            //         if (viewIdx > -1) {
            //             templateContext.viewContainerRef.remove(viewIdx);
            //         }
            //     }
            //     cellContext.viewRef = null;
            //     cellContext.rootElement = null;
            //     cellContext.column = null;
            //     cellContext.templateContextProperty = null;
            //     cell[templContextProp] = null;
            // }
        }
    };
    // ****** End Of framework specific overrides
    DirectiveCellFactoryBase.getTemplContextProp = function (templateType) {
        return '$__cellTempl' + GridCellTemplateType[templateType];
    };
    DirectiveCellFactoryBase.prototype._doDisposeCell = function (cell) {
        this.doDisposeCell(cell);
    };
    // finds a first input element in the edit template and initializes it with a data typed by keyboard
    // private _initEditInput(cellContext: _ICellTemplateCache, templContext: WjFlexGridCellTemplate,
    DirectiveCellFactoryBase.prototype._initEditInput = function (cellContext, templContext, initialValue) {
        var _this = this;
        // let setFocus = this.grid._edtFocus !== false;
        // this.grid._edtFocus = null;
        this.setEditorFocusFlag(true);
        var setFocus = this.getEditorFocusFlag() !== false;
        this.setEditorFocusFlag(null);
        this._setFullEdit(templContext);
        if (setFocus) {
            var input_1 = this._findInitialInput(cellContext);
            if (input_1) {
                var inpFocusEh = function () {
                    input_1.removeEventListener('focus', inpFocusEh);
                    setTimeout(function () {
                        var value = initialValue != null ? initialValue : _this._editChar;
                        if (value) {
                            input_1.value = value;
                            _this._editChar = null;
                            DirectiveCellFactoryBase._setSelectionRange(input_1, value.length, value.length);
                            input_1.dispatchEvent(_this._evtInput);
                        }
                    }, DirectiveCellFactoryBase._FOCUS_INTERVAL);
                };
                input_1.addEventListener('focus', inpFocusEh);
                input_1.focus();
            }
        }
    };
    //private _initImeEditInput(cellContext: _ICellTemplateCache, templContext: WjFlexGridCellTemplate) {
    DirectiveCellFactoryBase.prototype._initImeEditInput = function (cellContext, templContext) {
        var _this = this;
        //console.log(`_initImeEditInput, composing = ${this._composing}`)
        var imeEditor = wjcCore.getActiveElement();
        if (imeEditor &&
            (imeEditor instanceof HTMLInputElement ||
                imeEditor instanceof HTMLTextAreaElement) &&
            wjcCore.hasClass(imeEditor, wjcGrid.FlexGridClsNames.gridIme)) {
            var templateInput_1 = this._findInitialInput(cellContext), templateInputColor_1 = templateInput_1 && templateInput_1.style.color, isComposing_1 = this._composing;
            // if (input) {
            //     input.style.color = "transparent";
            // }
            var compEndEh_1 = function () {
                imeEditor.removeEventListener('compositionend', compEndEh_1);
                wjcCore.setCss(imeEditor, wjcGrid._ImeHandler._cssHidden);
                //console.log(`_initImeEditInput: hid ime editor`)
                // ensure that template's editor must be focused; otherwise, 
                // the value typed in imeEditor will not be propagated there
                _this.setEditorFocusFlag(true);
                // restore template editor's color, which we made transparent before.
                if (templateInput_1) {
                    templateInput_1.style.color = templateInputColor_1;
                }
                _this._initEditInput(cellContext, templContext, 
                //imeEditor.value);
                isComposing_1 ? imeEditor.value : null);
            };
            // If this is actually not an IME input (non-IME keyboard while grid.imeEnabled=true),
            // we emulate immediate 'compositionend'
            if (!isComposing_1) {
                //setTimeout(() => setTimeout(() => compEndEh(), 0), 0);
                setTimeout(function () { return compEndEh_1(); }, DirectiveCellFactoryBase._FOCUS_INTERVAL);
                //compEndEh();
            }
            else {
                imeEditor.addEventListener('compositionend', compEndEh_1);
                // position/size the editor
                //let templateInput = this._findInitialInput(cellContext);
                if (templateInput_1) {
                    var tRect = templateInput_1.getBoundingClientRect(), imeRect = imeEditor.getBoundingClientRect(), imeStyle = window.getComputedStyle(imeEditor), imeStyleLeft = parseFloat(imeStyle.left), imeStyleTop = parseFloat(imeStyle.top);
                    wjcCore.setCss(imeEditor, {
                        left: (imeStyleLeft + tRect.left - imeRect.left) + 'px',
                        top: (imeStyleTop + tRect.top - imeRect.top) + 'px',
                        width: tRect.width + 'px',
                        height: tRect.height + 'px'
                    });
                    // make template's editor text invisible, so that it doesn't mix with
                    // text of imeEditor, which can have a transparent background
                    templateInput_1.style.color = "transparent";
                }
            }
        }
    };
    //private _findInitialInput(cellContext: _ICellTemplateCache): HTMLInputElement | HTMLTextAreaElement {
    DirectiveCellFactoryBase.prototype._findInitialInput = function (cellContext) {
        var inputs = cellContext && cellContext.rootElement
            && cellContext.rootElement.querySelectorAll('input,textarea') || cellContext && cellContext.querySelectorAll('input,textarea');
        if (inputs) {
            for (var i = 0; i < inputs.length; i++) {
                var input = inputs[i], inpSt = window.getComputedStyle(input);
                if (inpSt.display !== 'none' && inpSt.visibility === 'visible') {
                    return input;
                }
            }
        }
        return null;
    };
    DirectiveCellFactoryBase._setSelectionRange = function (e, start, end) {
        if (end === void 0) { end = start; }
        //e = asType(e, HTMLInputElement);
        if (wjcCore.contains(document.body, e) && !e.disabled && e.style.display != 'none') {
            try {
                // use 'backward' to keep the start in view (but not in Edge! TFS 228053)
                e.setSelectionRange(wjcCore.asNumber(start), wjcCore.asNumber(end), wjcCore.isIE() ? null : 'backward');
                // focus needed in Chrome (TFS 124102, 142672) 
                // and after setRange (TFS 228053)
                e.focus();
            }
            catch (x) { }
        }
    };
    DirectiveCellFactoryBase.prototype._triggerEditorEvents = function (editCell) {
        if (editCell) {
            var cellCtrlElements = editCell.querySelectorAll("." + wjcCore.ControlClsNames.hostElement);
            for (var i = 0; i < cellCtrlElements.length; i++) {
                var curCtrlElement = cellCtrlElements[i], ctrl = wjcCore.Control.getControl(curCtrlElement);
                if (ctrl) {
                    // let behaviour = WjDirectiveBehavior.getBehavior(ctrl);
                    // if (behaviour) {
                    //     behaviour.flushPendingEvents();
                    // }
                    this.flushPendingEvents(ctrl);
                }
            }
        }
    };
    DirectiveCellFactoryBase.prototype._isFullEdit = function () {
        var grid = this.grid;
        return !grid.activeEditor || grid._edtHdl._fullEdit;
    };
    //private _setFullEdit(templContext: WjFlexGridCellTemplate) {
    DirectiveCellFactoryBase.prototype._setFullEdit = function (templContext) {
        var grid = this.grid;
        if (templContext.forceFullEdit && grid.activeEditor) {
            grid._edtHdl._fullEdit = true;
        }
    };
    DirectiveCellFactoryBase._cellStampProp = '__wjCellStamp';
    DirectiveCellFactoryBase._FOCUS_INTERVAL = wjcCore.Control._FOCUS_INTERVAL + 20; // TFS 316133
    return DirectiveCellFactoryBase;
}(wjcGrid.CellFactory));
export { DirectiveCellFactoryBase };
// Remove wijmo.grid mockup after DirectiveCellFactory has been loaded.
if (!__gridCFRef) {
    window['wijmo'].grid = null;
}
/**
* Defines the type of cell on which a template is to be applied. This value is specified in the <b>cellType</b> attribute
* of the frameworks' cell template components/directives.
*/
export var GridCellTemplateType;
(function (GridCellTemplateType) {
    /** Defines a regular (data) cell. */
    GridCellTemplateType[GridCellTemplateType["Cell"] = 0] = "Cell";
    /** Defines a cell in edit mode. */
    GridCellTemplateType[GridCellTemplateType["CellEdit"] = 1] = "CellEdit";
    /** Defines a column header cell. */
    GridCellTemplateType[GridCellTemplateType["ColumnHeader"] = 2] = "ColumnHeader";
    /** Defines a row header cell. */
    GridCellTemplateType[GridCellTemplateType["RowHeader"] = 3] = "RowHeader";
    /** Defines a row header cell in edit mode. */
    GridCellTemplateType[GridCellTemplateType["RowHeaderEdit"] = 4] = "RowHeaderEdit";
    /** Defines a top left cell. */
    GridCellTemplateType[GridCellTemplateType["TopLeft"] = 5] = "TopLeft";
    /** Defines a group header cell in a group row. */
    GridCellTemplateType[GridCellTemplateType["GroupHeader"] = 6] = "GroupHeader";
    /** Defines a regular cell in a group row. */
    GridCellTemplateType[GridCellTemplateType["Group"] = 7] = "Group";
    /** Defines a cell in a new row template. */
    GridCellTemplateType[GridCellTemplateType["NewCellTemplate"] = 8] = "NewCellTemplate";
    /** Defines a column footer cell. */
    GridCellTemplateType[GridCellTemplateType["ColumnFooter"] = 9] = "ColumnFooter";
    /** Defines a bottom left cell (at the intersection of the row header and column footer cells). **/
    GridCellTemplateType[GridCellTemplateType["BottomLeft"] = 10] = "BottomLeft";
})(GridCellTemplateType || (GridCellTemplateType = {}));
// Entry file. All real code files should be re-exported from here.
_registerModule('wijmo.interop.grid', selfModule);
